module.exports = __webpack_public_path__ + "img/social-pinterest.e2b2c6bf.svg";